import { defineMessages } from 'react-intl';

export default defineMessages({
  claimNumber: {
    id: 'claims.claim_number',
  },
  client: {
    id: 'claims.client',
  },
  lossDate: {
    id: 'claims.loss_date',
  },
  openingDate: {
    id: 'claims.opening_date',
  },
  numberOfVictim: {
    id: 'claims.number_of_victim',
  },
  preOpeningDate: {
    id: 'claims.preopening_date',
  },
  title: {
    id: 'pending_treatement_claims.manager.title',
  },
  lossHour: {
    id: 'claims.loss_hour',
  },
  claimPlace: {
    id: 'claims.claim_place',
  },
  registrationNumber: {
    id: 'claims.registration_number',
  },
  lawyer: {
    id: 'claims.lawyer',
  },
  linesPerPage: {
    id: 'lines_per_page',
  },
  preOpenDate: {
    id: 'claims.opening_date',
  },
  registrationNumberCriteria: {
    id: 'lawyer.documents_table.table_header.registration_number',
  },
  inboxesTitle: {
    id: 'pending_treatement_claims.table.inboxes',
  },
  taskTitle: {
    id: 'pending_treatement_claims.table.task',
  },
  areaTitle: {
    id: 'transaction.pending_ttreatement.area_title',
  },
});
